// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"30\" height=\"26\" viewBox=\"0 0 30 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28.3336 18.3333L22.7083 13.8333C22.1336 13.3733 21.2936 13.4667 20.8336 14.0413L16.3856 19.6013C15.9256 20.176 15.0869 20.2693 14.5109 19.8093L12.0203 17.816C11.4536 17.3627 10.6283 17.4453 10.1629 18.004L4.33359 25M25.6629 25H4.33756C2.86423 25 1.6709 23.8067 1.6709 22.3333V3.66667C1.6709 2.19333 2.86423 1 4.33756 1H25.6629C27.1362 1 28.3296 2.19333 28.3296 3.66667V22.3333C28.3296 23.8067 27.1349 25 25.6629 25ZM11.5525 7.11439C12.5939 8.15578 12.5939 9.84423 11.5525 10.8856C10.5111 11.927 8.8227 11.927 7.7813 10.8856C6.7399 9.84423 6.7399 8.15579 7.7813 7.11439C8.8227 6.07299 10.5111 6.07299 11.5525 7.11439Z\" stroke=\"#98A1B3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-article {
	height: 160px;
	width: 100%;
	margin: 16px 0;
	padding: 20px;
	background-image:
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
		linear-gradient(to right, #DDE3F0, 160px, #F2F5FA 160px, #F2F5FA)
	;
	background-position: 66px center, 0 0;
	background-size: 30px auto, 100%;
	background-repeat: no-repeat;
	border-radius: 6px;
	font-family: sans-serif;
	padding-left: 176px;
	overflow: hidden;
	position: relative;
}

.related-article::before {
	content: 'Related article';
	display: block;
	margin-bottom: 8px;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	color: #7A8599;
	font-size: 10px;
	line-height: 1.4;
}

.related-article::after {
	content: '';
	display: block;
	position: absolute;
	right: 0;
	bottom: 0;
	width: calc(100% - 160px);
	height: 40px;
	background-image: linear-gradient(0deg, #f2f5fa 12px, transparent);
	z-index: 10;
}

.related-article__title {
	margin-bottom: 8px;
	font-size: 16px;
	font-weight: bold;
	line-height: 1.25;
	color: #4F5259;
}

.related-article__description {
	font-size: 13px;
	line-height: 1.23;
	color: #7A8599;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/related-article/styles.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,WAAW;CACX,cAAc;CACd,aAAa;CACb;;;CAGA;CACA,qCAAqC;CACrC,gCAAgC;CAChC,4BAA4B;CAC5B,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,yBAAyB;CACzB,YAAY;CACZ,kEAAkE;CAClE,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf","sourcesContent":[".related-article {\n\theight: 160px;\n\twidth: 100%;\n\tmargin: 16px 0;\n\tpadding: 20px;\n\tbackground-image:\n\t\turl('data:image/svg+xml,<svg width=\"30\" height=\"26\" viewBox=\"0 0 30 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28.3336 18.3333L22.7083 13.8333C22.1336 13.3733 21.2936 13.4667 20.8336 14.0413L16.3856 19.6013C15.9256 20.176 15.0869 20.2693 14.5109 19.8093L12.0203 17.816C11.4536 17.3627 10.6283 17.4453 10.1629 18.004L4.33359 25M25.6629 25H4.33756C2.86423 25 1.6709 23.8067 1.6709 22.3333V3.66667C1.6709 2.19333 2.86423 1 4.33756 1H25.6629C27.1362 1 28.3296 2.19333 28.3296 3.66667V22.3333C28.3296 23.8067 27.1349 25 25.6629 25ZM11.5525 7.11439C12.5939 8.15578 12.5939 9.84423 11.5525 10.8856C10.5111 11.927 8.8227 11.927 7.7813 10.8856C6.7399 9.84423 6.7399 8.15579 7.7813 7.11439C8.8227 6.07299 10.5111 6.07299 11.5525 7.11439Z\" stroke=\"#98A1B3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>'),\n\t\tlinear-gradient(to right, #DDE3F0, 160px, #F2F5FA 160px, #F2F5FA)\n\t;\n\tbackground-position: 66px center, 0 0;\n\tbackground-size: 30px auto, 100%;\n\tbackground-repeat: no-repeat;\n\tborder-radius: 6px;\n\tfont-family: sans-serif;\n\tpadding-left: 176px;\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.related-article::before {\n\tcontent: 'Related article';\n\tdisplay: block;\n\tmargin-bottom: 8px;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.07em;\n\tcolor: #7A8599;\n\tfont-size: 10px;\n\tline-height: 1.4;\n}\n\n.related-article::after {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: calc(100% - 160px);\n\theight: 40px;\n\tbackground-image: linear-gradient(0deg, #f2f5fa 12px, transparent);\n\tz-index: 10;\n}\n\n.related-article__title {\n\tmargin-bottom: 8px;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tline-height: 1.25;\n\tcolor: #4F5259;\n}\n\n.related-article__description {\n\tfont-size: 13px;\n\tline-height: 1.23;\n\tcolor: #7A8599;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
